<template>
  <div style="text-align: center;">
    <div>
      <div style="margin: 64px 0">
        <img src="@/assets/images/logo.png" alt="Logo" style="width: 100%; max-width: 640px">
      </div>
      <div style="margin: 64px 0; font-size: 32px; font-weight: 600;">
        欢迎使用{{ title }}
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'WelcomeTab',
  data () {
    return {
      title: config.title
    }
  }
}
</script>
